import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

export const isOpenModalSelector = createSelector(
  (state: RootState) => state.modalState,
  (state) => state.isOpen,
);

export const getModalPropsSelector = createSelector(
  (state: RootState) => state.modalState,
  (state) => state.props,
);
